// eslint-disable-next-line @typescript-eslint/typedef
export const BufferControllerEvents = {
  requestResetWithOverplay: 'buffer.requestResetWithOverplay',
  bufferStalled: 'buffer.stalled',
  bufferMetricsAvailable: 'buffer.metricsAvaialable',
  playbackStallChanged: 'buffer.playbackStallChanged',
  requestSourceBufferOperation: 'buffer.requestSourceBufferOperation',
  playbackStateChanged: 'buffer.playbackStateChanged',
  endOfStreamReached: 'buffer.endOfStreamReached',
  onFragmentAppended: 'buffer.onFragmentAppended',
  fragmentAdded: 'buffer.fragmentAdded',
  changeCodec: 'buffer.changeCodec',
  sourceBufferStuck: 'buffer.sourceBufferStuck',
  latencyExtraInformationAvailable: 'buffer.latencyExtraInformationAvailable',
};
